<template>
<div>
    <form @reset="onReset" class="item-editor-form">
        <fg-input v-model="form.layoutName" :label="$t('display_layouts.layout_name')" :disabled="disabled"></fg-input>

        <div class="color-box" v-for="parameter in parameters" :key="parameter.name">
            <label>{{ $t('display_layouts.parameters.'+ parameter.name) }}</label>
            <button @click.prevent="showModal(parameter.name)" :style="{ 'background-color': form.layoutConfiguration[parameter.name] }" :disabled="disabled" > 
                {{ $t('deviation_settings.choose_color') }}  
            </button>
        </div>

        <FormButtons
            @submit="onSubmit"
            :submit="$UIPrivilegeU('content/displaylayouts')"  
            :reset="false"
            :remove="action == 'edit' && $UIPrivilegeD('content/displaylayouts')"
            @remove="remove"
            :disableSubmit="!inputChanged || loading"
            :disableRemove="disabled || loading "/>

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
    </form>
    <DeleteModal :itemid="selectedLayout ? selectedLayout.displayLayoutId : ''" @ok="onDeleteOK" />

    <b-modal 
        id='color-modal' 
        :title="$t('deviation_settings.choose_color')"
        class="color-modal"
        hide-footer >
        <swatches-picker v-model="selectedColor" @input="colorChanged" />
    </b-modal> 

</div>
</template>

<script>
import displayLayout from '@/store/displays/displayLayout'
import { Swatches } from 'vue-color'

export default {
    name: 'DisplayLayoutEditForm',
    props: {
        item: { default: null },
        action: { default: "empty" }
    },
    components: {
        'swatches-picker': Swatches,
    },
    data: function() {
        return  {
            disabled: false,
            selectedColor: "#FF0000",
            selectedParameter: null,
            defaultFormData: {
                displayLayoutId: null,
                layoutName: null,
                layoutConfiguration: {
                  title_foreground:"#FFFFFF"
                  ,clock_foreground:"#FFFFFF"
                  ,timetable_foreground:"#FFFFFF"
                  ,announcement_foreground:"#FFFFFF"
                  ,timetable_header_foreground:"#FFFFFF"
                  }
            },
            form: {
                'displayLayoutId': null,
                'layoutName': null,
                'layoutConfiguration': {}
            },
            ok: false,
            error: false,
            loading: false,
            infoType: "save",
        }
    },
    mounted() {
      if(this.$props.action == 'new')
        this.newLayout();
    },
    computed: {
        resetDisabled() {
            return this.form.displayLayoutId == null;
        },
        selectedLayout() {
            return this.item;
        },
        inputChanged() {
            if (this.selectedLayout) {
                var configurationChanged = false;
                for (const p of this.$store.state.displayLayout.layoutParameterList) {
                    if (this.form.layoutConfiguration[p.name] != this.selectedLayout.layoutConfiguration[p.name]) {
                        configurationChanged = true;
                        break;
                    }
                }
                return configurationChanged
                        || (this.form.displayLayoutId != this.selectedLayout.displayLayoutId)
                        || (this.form.layoutName != this.selectedLayout.layoutName)
            }
            return true;
        },
        parameters() {
            return this.$store.state.displayLayout.layoutParameterList;
        }
    },
    watch: {
        item() {
            this.ok = this.error = this.loading = this.disabled = false;
            this.copyItemData();
        }
    },
    methods: {
        newLayout() {
            this.form = Object.assign({}, this.defaultFormData);
            this.disabled = false; 
        },
        onSubmit(event) {
            if (event) event.preventDefault();

            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = this.disabled = true;
          
            this.$store.dispatch('displayLayout/saveLayout', this.form).then(response => {
                setTimeout(() => { 
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                    this.loading = this.disabled = false;
                }, 1000);
             })
            .catch(() => { this.error = true; })
            .finally();
        },
        onReset(event) {
            event.preventDefault();
            this.$store.commit('displayLayout/changeSelectedLayout', null);
            this.form = this.defaultFormData;
            this.disabled = true;
        },
        remove() {
            this.$bvModal.show('delete-modal')
        },
        onDeleteOK() {
            this.infoType = "delete";
            this.loading = this.disabled = true;
            this.$store.dispatch('displayLayout/deleteLayout', this.selectedLayout.displayLayoutId).then(response => {
                setTimeout(() => { 
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                    this.loading = false;
                }, 1000);
            }, () => {
                
            });
        },
        copyItemData() {
            if (this.item) {
                this.form = JSON.parse(JSON.stringify(this.item))
            }
        },
        showModal(parameter){
            if(parameter != null){
                this.selectedParameter = parameter;
                this.$bvModal.show('color-modal')
                this.selectedColor = this.form.layoutConfiguration[parameter]
            }
        },
        colorChanged(){
            if(this.selectedParameter != null){
                    this.form.layoutConfiguration[this.selectedParameter] = this.selectedColor.hex;
                    this.$bvModal.hide('color-modal')
            }
        }
    },
    beforeCreate: function() {
        if (!this.$store.state.displayLayout) {
             this.$store.registerModule("displayLayout", displayLayout);
        }
        this.$store.dispatch('displayLayout/getLayoutParameterList');
    },
    created() {
        this.copyItemData();
    }
}
</script>

<style scoped lang="scss" >
    @import 'vue-select/src/scss/vue-select.scss';

    .color-box { 
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        flex: 4;

        button {
            width: 100%;
            font-size: 1em;
            padding: 10px 10px 10px 10px;
            border-radius: 4px;
            border: 1px solid #ddd;
            margin: 0;
            height: calc(1.5em + .75rem + 2px);
            line-height: normal;
        }

        label {
            font-size: .8571em;
            color: #9a9a9a;
            margin-bottom: 5px;
            width: 100%;
        }
    }

</style>
